import { observer } from "mobx-react";
import FontBody1 from "../../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../../components/fonts/font-props";
import { Input } from "../../../../../../../../components/inputs/input/input";
import { IOption, SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import currentPortalStore from "../../../../../../../../stores/current-portal-store";
import portalStore from "../../../../../../../../stores/current-portal-store";
import { CREDIT_AMOUNT_TYPE, RESOLUTION_TYPE } from "../../../../../../constants";
import resolutionListStore from "../../../../../../stores/resolution-list-store";
import { RefundTypeProps } from "../refund-type-props";

const RefundAmount: React.FC<RefundTypeProps> = observer(({resolution, validationGroup}) => {
    const platform = currentPortalStore.platform;
    const refundTypes = resolutionListStore.settings.refund_types.filter(option => platform?.isResolutionSupportedByType(option.value as RESOLUTION_TYPE));
    
    const storeCurrency = portalStore.setting?.currencyCode;

    const refundAmountTypes = [
        { value: CREDIT_AMOUNT_TYPE.PAID_AMOUNT, label: 'Paid amount' },
        { value: CREDIT_AMOUNT_TYPE.MORE, label: 'Add incentive' },
        { value: CREDIT_AMOUNT_TYPE.LESS, label: 'Reduced refund' },
        { value: CREDIT_AMOUNT_TYPE.FIXED, label: 'Fixed amount' },
    ];
    const selectedRefundAmountType = refundAmountTypes.find(type => type.value === resolution?.creditAmountType);

    const isPercentageOptions: IOption[] = [
        { value: 0, label: storeCurrency as string },
        { value: 1, label: '%' },
    ];
    const selectedIsPercentage = isPercentageOptions.find(c => !!c.value === !!resolution?.isPercentage);

    const selectedRefundTyoe = refundTypes.find(type => (type.value as unknown) === resolution?.resolutionType);

    const modifyCreditAmountDisabled = selectedRefundAmountType?.value === CREDIT_AMOUNT_TYPE.PAID_AMOUNT;
    const isPercentageDisabled = [CREDIT_AMOUNT_TYPE.PAID_AMOUNT, CREDIT_AMOUNT_TYPE.FIXED]
            .includes(selectedRefundAmountType?.value as CREDIT_AMOUNT_TYPE);

    const getMaxModifyCreditAmountValue = () => {
        if (!resolution?.isPercentage) {
            return 999999.99;
        }

        switch (resolution?.resolutionType) {
            case RESOLUTION_TYPE.BankRefund:
            case RESOLUTION_TYPE.Refund:
            case RESOLUTION_TYPE.InstantRefundType:
                return 100;
            case RESOLUTION_TYPE.Credits:
            case RESOLUTION_TYPE.PlatformStoreCreditType:
            case RESOLUTION_TYPE.GiftCard:
                return 150;
            default: 
                throw Error('getMaxModifyCreditAmountValue: resolutionType is not supported');
        }
    };

    return (
        <div className="credit-amount-type">
            <div className="credit-amount-type-fields">
                <SelectDropdown
                    value={selectedRefundAmountType}
                    options={refundAmountTypes}
                    onChange={(v) => {
                        if (v) {
                            resolution?.setCreditAmountType(v.value as number);
                        }

                        if (resolution?.creditAmountType === CREDIT_AMOUNT_TYPE.FIXED) {
                            resolution?.setIsPercentage(false);
                        }

                        if (resolution?.creditAmountType === CREDIT_AMOUNT_TYPE.PAID_AMOUNT) {
                            resolution?.setIsPercentage(true);
                            resolution?.setModifyCreditAmount(100);
                        }

                    }}
                    required
                    validationGroup={validationGroup} />

                <Input
                    type={'number'}
                    min={0}
                    max={getMaxModifyCreditAmountValue()}
                    value={resolution?.modifyCreditAmount ?? 0}
                    onChange={v => resolution?.setModifyCreditAmount(v)}
                    disabled={modifyCreditAmountDisabled}
                />

                <SelectDropdown
                    value={selectedIsPercentage}
                    options={isPercentageOptions}
                    onChange={(v) => {
                        if (v) {
                            resolution?.setIsPercentage(!!v.value);
                        }
                    }}
                    disabled={isPercentageDisabled}
                    required
                    validationGroup={validationGroup} />
            </div>
            <div>
                <FontBody1 color={FONT_COLOR.PRIMARY3_50}>{selectedRefundTyoe?.label} = </FontBody1>
                {![CREDIT_AMOUNT_TYPE.FIXED, CREDIT_AMOUNT_TYPE.PAID_AMOUNT].includes(resolution?.creditAmountType as CREDIT_AMOUNT_TYPE) &&
                    <>
                        <FontBody1 color={FONT_COLOR.PRIMARY3_50}>
                            paid amount
                            {selectedRefundAmountType?.value === CREDIT_AMOUNT_TYPE.LESS
                                ? <> - </>
                                : <> + </>
                            }
                        </FontBody1>
                    </>
                }
                {resolution?.creditAmountType === CREDIT_AMOUNT_TYPE.PAID_AMOUNT ?
                    <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY1}>Paid amount</FontBody1>
                    :
                    <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY1}>
                        {resolution?.modifyCreditAmount}{selectedIsPercentage?.label}
                    </FontBody1>
                }
                
            </div>
        </div>
    );
});

export default RefundAmount;